/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */

/* eslint-disable react/forbid-prop-types */
import React, { useRef, useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppAsyncSelect from '../../../shared/components/app-async-select/AppAsyncSelect';
import { debounce } from '../../../api/apiUtils';
import { getAirportsApi } from '../../../api/flightApi';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppNumberInput from '../../../shared/components/app-number-input/AppNumberInput';
import AppDatePicker from '../../../shared/components/app-date-picker/AppDatePicker';
import { getNewDate } from '../../../shared/helper-utils/appUtils';

const DEBOUNCE_DELAY = 500;

const CARRIER_OPTIONS = [
  { label: '6E', value: '6E' },
  { label: 'G8', value: 'G8' },
  { label: 'SG', value: 'SG' },
  { label: 'I5', value: 'I5' },
  { label: 'AI', value: 'AI' },
  { label: 'UK', value: 'UK' },
  { label: 'S9', value: 'S9' },
  { label: 'QP', value: 'QP' },
  { label: '9I', value: '9I' },
];

const TRAVEL_TYPE = [
  { label: 'Domestic', value: 'domestic' },
  { label: 'International', value: 'international' },
];

const STATUS_TYPE = [
  { label: 'Active', value: 'active' },
  { label: 'In Active', value: 'inactive' },
];
const YES_NO = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];
const TRUE_FALSE = [
  { label: 'True', value: 'true' },
  { label: 'False', value: 'false' },
];
const JOURNEY_TYPE = [
  { label: 'One Way', value: 'Oneway' },
  { label: 'Round Trip', value: 'RoundTrip' },
];

export function AirportOption(props) {
  return (
    <div
      onClick={() => props.selectOption(props.data)}
      className={`${props.isFocused ? 'airport-focused' : ''} airport-option`}
      key={props.value}
    >
      <div className="d-flex">
        <span className="airport-option__code">{props.data.AirportCode}</span>
        <div className="d-flex flex-column airport-option__other">
          <span className="airport-option__other_location">
            {props.data.AirportLocation.split(',')[0]}
          </span>
          <span className="airport-option__other_name">
            {props.data.AirportName}
          </span>
        </div>
      </div>
    </div>
  );
}

function EditCoupon({ coupon }) {
  const originAirportRef = useRef(null);
  const destinationAirportRef = useRef(null);
  const [couponDetails, setCouponDetails] = useState(undefined);

  useEffect(() => {
    if (coupon) {
      setCouponDetails((prevState) => ({
        ...prevState,
        couponid: coupon.Couponid,
        coupon_origin: coupon.CouponOrigin,
        coupon_destination: coupon.CouponDestination,
        issingledate: coupon.IsSingleDate,
        validjdates_end: getNewDate(coupon.ValidJdatesEnd),
        coupon_validity: getNewDate(coupon.CouponValidity),
        coupon_class: coupon.CarrierCode,
        isconnecting: coupon.IsConnecting.toString().toLowerCase(),
        numcoupons_booklet: coupon.NumCouponsBooklet,
        totalcoupons: coupon.TotalCoupons,
        availablecoupons: coupon.AvailableCoupons,
        addedby: coupon.AddedBy,
        carriercode: coupon.CarrierCode,
        status: coupon.Status,
        basefare: coupon.basefare,
        tax: coupon.Tax,
        yq: coupon.YQ,
        domint: coupon.DomInt,
        total_amount: coupon.TotalAmount,
        flightnumber: coupon.FlightNumber,
        deptime: coupon.Deptime.toString().padStart(4, '0'),
        arrtime: coupon.Arrtime.toString().padStart(4, '0'),
        totalduration: coupon.TotalDuration,
        checkrealtimeavail: coupon.CheckRealTimeAvail.toString().toLowerCase(),
        realtimeavail_supplierid: coupon.RealTimeAvailSupplier,
        validjdates: coupon.ValidJdates,
        childbasefare: coupon.ChildBaseFare,
        childyq: coupon.ChildTax,
        childtax: coupon.ChildTax,
        infantbasefare: coupon.InfantBaseFare,
        infantyq: coupon.InfantYQ,
        infanttax: coupon.InfantTax,
        hiddenmarkup: coupon.HiddenMarkup,
        coupontype: coupon.CouponType,
        checkliveavail: coupon.CheckLiveAvail,
        jtype: coupon.JType,
        issplrt: coupon.Issplrt.toString().toLowerCase(),
        isdaywiseavail: coupon.IsDaywiseAvail.toString().toLowerCase(),
      }));
    }
  }, []);

  const handleUpDateState = (name, value) => {
    setCouponDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const loadAirportSuggestions = debounce(async (query, callback) => {
    let airports = [];
    if (query.length >= 3) {
      const response = await getAirportsApi(query);
      airports = response.map((airportNode) => ({
        label: `${airportNode.AirportCode} - ${airportNode.AirportLocation}`,
        value: airportNode.AirportCode,
        ...airportNode,
      }));
    }
    callback(airports);
  }, DEBOUNCE_DELAY);

  const handleAirportSelect = (airport, name) => {
    if (name === 'origin') {
      originAirportRef.current = airport;
      let originAirportCode = '';
      if (airport !== null) {
        originAirportCode = airport.value;
      }
      handleUpDateState('coupon_origin', originAirportCode);
    } else {
      destinationAirportRef.current = airport;
      let destinationAirportCode = '';
      if (airport !== null) {
        destinationAirportCode = airport.value;
      }
      handleUpDateState('coupon_destination', destinationAirportCode);
    }
  };
  return (
    couponDetails && (
      <div className="add-coupon p-3">
        <div className="add-coupon_details ">
          <div className="add-coupon_details_header">Coupon Details</div>
          <div className="add-coupon_details_content mt-3 fs-14">
            <Row className="justify-content-between spacing-0 p-3">
              <Col
                lg={5}
                md={6}
                sm={6}
                xs={12}
                className="d-flex flex-column gap-2 "
              >
                <AppAsyncSelect
                  placeholder="Enter origin"
                  name="origin"
                  components={{ Option: AirportOption }}
                  loadOptionsFn={loadAirportSuggestions}
                  selectWidth="w-100"
                  onSelect={handleAirportSelect}
                  selectedValue={originAirportRef.current}
                />
                <AppSelect
                  name="carrier"
                  id="carrier"
                  label="Carrier"
                  placeholder="Select Carrier"
                  required
                  isClearable={false}
                  selectedValue={couponDetails.carriercode}
                  onSelect={(d) => handleUpDateState('carriercode', d.value)}
                  options={CARRIER_OPTIONS}
                />
                <AppTextInput
                  name="class"
                  id="class"
                  required
                  label="Class"
                  placeholderText="class"
                  value={couponDetails.coupon_class}
                  onChange={(e) =>
                    handleUpDateState('coupon_class', e.target.value)
                  }
                />
                <AppNumberInput
                  name="arrtime"
                  id="arrtime"
                  required
                  label="Arrival Time(HHMM)"
                  value={couponDetails.arrtime}
                  onChange={(d) => handleUpDateState('arrtime', d)}
                />
                <AppSelect
                  name="travelType"
                  id="travelType"
                  label="Journey Type"
                  placeholder=""
                  required
                  isClearable={false}
                  selectedValue={couponDetails.domint}
                  options={TRAVEL_TYPE}
                  onSelect={(d) => handleUpDateState('domint', d.value)}
                />
                <AppTextInput
                  name="supplierid"
                  id="supplierid"
                  required
                  label="Real Supplier Id"
                  value={couponDetails.realtimeavail_supplierid}
                  readOnly
                />
              </Col>
              <Col
                lg={5}
                md={6}
                sm={6}
                xs={12}
                className="d-flex flex-column gap-2"
              >
                <AppAsyncSelect
                  placeholder="destination"
                  name="destination"
                  components={{ Option: AirportOption }}
                  loadOptionsFn={loadAirportSuggestions}
                  selectWidth="w-100"
                  onSelect={handleAirportSelect}
                  selectedValue={destinationAirportRef.current}
                />
                <AppTextInput
                  name="flightNumber"
                  id="flightNumber"
                  required
                  label="Flight Number"
                  value={couponDetails.flightnumber}
                  onChange={(e) =>
                    handleUpDateState('flightnumber', e.target.value)
                  }
                />
                <AppNumberInput
                  name="deptime"
                  id="deptime"
                  required
                  label="Departure Time (HHMM)"
                  value={couponDetails.deptime}
                  onChange={(d) => handleUpDateState('deptime', d)}
                />
                <AppNumberInput
                  name="duration"
                  id="duration"
                  required
                  label="Total Duration"
                  value={couponDetails.totalduration}
                  onChange={(e) => handleUpDateState('totalduration', e)}
                />
                <AppSelect
                  name="status"
                  id="status"
                  label="Status"
                  placeholder=""
                  required
                  isClearable={false}
                  selectedValue={couponDetails.status}
                  options={STATUS_TYPE}
                  onSelect={(d) => handleUpDateState('status', d.value)}
                />
              </Col>
            </Row>
          </div>
        </div>
        <div className="add-coupon_details ">
          <div className="add-coupon_details_header">Availability Details</div>
          <div className="add-coupon_details_content mt-3 fs-14">
            <Row className="justify-content-between spacing-0 p-3">
              <Col
                lg={5}
                md={6}
                sm={6}
                xs={12}
                className="d-flex flex-column gap-2"
              >
                <AppSelect
                  name="isdayavail"
                  id="isdayavail"
                  label="Is Day Avail"
                  placeholder="Select"
                  required
                  selectedValue="true"
                  isClearable={false}
                  options={[{ label: 'True', value: 'true' }]}
                  onSelect={(d) => handleUpDateState('isdaywiseavail', d.value)}
                />
                <AppNumberInput
                  name="availablecoupons"
                  id="availablecoupons"
                  required
                  label="Available Coupons"
                  value={couponDetails.availablecoupons}
                  onChange={(d) => handleUpDateState('availablecoupons', d)}
                />
                <AppSelect
                  name="availability"
                  id="availability"
                  label="Availability"
                  placeholder=""
                  required
                  isClearable={false}
                  selectedValue={couponDetails.checkliveavail}
                  options={YES_NO}
                  onSelect={(d) => handleUpDateState('checkliveavail', d.value)}
                />
                <AppSelect
                  name="realtimeavailability"
                  id="realtimeavailability"
                  label="Real Time Availability"
                  placeholder=""
                  required
                  isClearable={false}
                  selectedValue={couponDetails.checkrealtimeavail}
                  options={TRUE_FALSE}
                  onSelect={(d) =>
                    handleUpDateState('checkrealtimeavail', d.value)
                  }
                />
              </Col>
              <Col
                lg={5}
                md={6}
                sm={6}
                xs={12}
                className="d-flex flex-column gap-2"
              >
                <AppNumberInput
                  name="totalcoupons"
                  id="totalcoupons"
                  required
                  label="Total Coupons"
                  value={couponDetails.totalcoupons}
                  onChange={(d) => handleUpDateState('totalcoupons', d)}
                />
                <AppSelect
                  name="coupontype"
                  id="coupontype"
                  label="Coupon Type"
                  placeholder=""
                  required
                  isClearable={false}
                  selectedValue="series"
                  options={[{ label: 'Series', value: 'series' }]}
                  onSelect={(d) => handleUpDateState('coupontype', d.value)}
                />
                <AppSelect
                  name="connectivity"
                  id="connectivity"
                  label="Connectivity"
                  placeholder=""
                  required
                  isClearable={false}
                  selectedValue={couponDetails.isconnecting}
                  options={TRUE_FALSE}
                  onSelect={(d) => handleUpDateState('isconnecting', d.value)}
                />
              </Col>
            </Row>
          </div>
        </div>
        <div className="add-coupon_details ">
          <div className="add-coupon_details_header">Validity</div>
          <div className="add-coupon_details_content mt-3 fs-14">
            <Row className="justify-content-between spacing-0 p-3">
              <Col
                lg={5}
                md={6}
                sm={6}
                xs={12}
                className="d-flex flex-column gap-2"
              >
                <AppDatePicker
                  name="jdate"
                  id="jdate"
                  required
                  label="Journey Date"
                  className="fs-dep-date-input"
                  customClassName="app-date-picker"
                  value={couponDetails.validjdates}
                  onChange={(date) => handleUpDateState('validjdates', date)}
                />
                <AppSelect
                  name="issingledate"
                  id="issingledate"
                  label="Is Single Date"
                  placeholder=""
                  required
                  selectedValue="no"
                  isClearable={false}
                  options={[{ label: 'No', value: 'no' }]}
                  onSelect={(d) => handleUpDateState('issingledate', d.value)}
                />
              </Col>
              <Col
                lg={5}
                md={6}
                sm={6}
                xs={12}
                className="d-flex flex-column gap-2"
              >
                <AppDatePicker
                  name="endjourneydate"
                  id="endjourneydate"
                  required
                  label="End Journey Date"
                  className="fs-dep-date-input"
                  customClassName="app-date-picker"
                  value={couponDetails.validjdates_end}
                  onChange={(date) =>
                    handleUpDateState('validjdates_end', date)
                  }
                />
                <AppDatePicker
                  name="validity"
                  id="validity"
                  required
                  label="Validity"
                  className="fs-dep-date-input"
                  customClassName="app-date-picker"
                  value={couponDetails.validjdates_end}
                  onChange={(date) =>
                    handleUpDateState('validjdates_end', date)
                  }
                />
              </Col>
            </Row>
          </div>
        </div>
        <div className="add-coupon_details ">
          <div className="add-coupon_details_header">Fare Details</div>
          <div className="add-coupon_details_content mt-3 fs-14">
            <Row className="justify-content-between spacing-0 p-3">
              <Col
                lg={5}
                md={6}
                sm={6}
                xs={12}
                className="d-flex flex-column gap-2"
              >
                <AppTextInput
                  name="basefare"
                  id="basefare"
                  required
                  label="Basefare"
                  value={couponDetails.basefare}
                  onChange={(e) =>
                    handleUpDateState('basefare', e.target.value)
                  }
                />
                <AppTextInput
                  name="yq"
                  id="yq"
                  required
                  label="Yq"
                  value={couponDetails.yq}
                  onChange={(e) => handleUpDateState('yq', e.target.value)}
                />
                <AppTextInput
                  name="childbasefare"
                  id="childbasefare"
                  required
                  label="Child BaseFare"
                  value={couponDetails.childbasefare}
                  onChange={(e) =>
                    handleUpDateState('childbasefare', e.target.value)
                  }
                />
                <AppTextInput
                  name="childyq"
                  id="childyq"
                  required
                  label="Child Yq"
                  value={couponDetails.childyq}
                  onChange={(e) => handleUpDateState('childyq', e.target.value)}
                />
                <AppTextInput
                  name="infantbasefare"
                  id="infantbasefare"
                  required
                  label="InfantBaseFare"
                  value={couponDetails.infantbasefare}
                  onChange={(e) =>
                    handleUpDateState('infantbasefare', e.target.value)
                  }
                />
                <AppTextInput
                  name="infantyq"
                  id="infantyq"
                  required
                  label="Infantyq"
                  value={couponDetails.infantyq}
                  onChange={(e) =>
                    handleUpDateState('infantyq', e.target.value)
                  }
                />
              </Col>
              <Col
                lg={5}
                md={6}
                sm={6}
                xs={12}
                className="d-flex flex-column gap-2"
              >
                <AppTextInput
                  name="tax"
                  id="tax"
                  required
                  label="Tax"
                  value={couponDetails.tax}
                  onChange={(e) => handleUpDateState('tax', e.target.value)}
                />
                <AppTextInput
                  name="totalamount"
                  id="totalamount"
                  required
                  label="Total Amount"
                  value={couponDetails.total_amount}
                  onChange={(e) =>
                    handleUpDateState('total_amount', e.target.value)
                  }
                />
                <AppTextInput
                  name="childtax"
                  id="childtax"
                  required
                  label="Child Tax"
                  value={couponDetails.childtax}
                  onChange={(e) =>
                    handleUpDateState('childtax', e.target.value)
                  }
                />
                <AppTextInput
                  name="infanttax"
                  id="infanttax"
                  required
                  label="Infant Tax"
                  value={couponDetails.infanttax}
                  onChange={(e) =>
                    handleUpDateState('infanttax', e.target.value)
                  }
                />
                <AppTextInput
                  name="markup"
                  id="markup"
                  required
                  label="Markup"
                  value={couponDetails.hiddenmarkup}
                  onChange={(e) =>
                    handleUpDateState('hiddenmarkup', e.target.value)
                  }
                />
                <AppSelect
                  name="jtype"
                  id="jtype"
                  label="JType"
                  placeholder=""
                  required
                  isClearable={false}
                  selectedValue={couponDetails.jtype}
                  options={JOURNEY_TYPE}
                  onSelect={(d) => handleUpDateState('jtype', d.value)}
                />
                {couponDetails.jtype === 'RoundTrip' && (
                  <AppSelect
                    name="splRT"
                    id="splRT"
                    label="Spl RT"
                    placeholder=""
                    required
                    isClearable={false}
                    selectedValue={couponDetails.issplrt}
                    options={TRUE_FALSE}
                    onSelect={(d) => handleUpDateState('issplrt', d.value)}
                  />
                )}
              </Col>
            </Row>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <AppButton btnText="Continue" variant="primary" className="px-4" />
        </div>
      </div>
    )
  );
}

EditCoupon.propTypes = {
  coupon: PropTypes.object.isRequired,
};

export default EditCoupon;
